import {useEffect, useMemo} from "react";
import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	SelectField,
	InputField,
} from "~/components/Forms";
import {CAREERS} from "../../../../app/constants";
import {Col, Row} from "antd";

function CreatedWebsiteFormEdit({item, onHandleSubmit}) {

	const careerOptions = CAREERS;

	const statusShareOptions = [
		{value : 0, label : "Riêng tư"},
		{value : 1, label : "Công khai"},
	];

	const initialValues = {
		career: item?.career,
		statusShare: item?.statusShare,
	}

	const { control, handleSubmit,
		formState: {
			isSubmitting,
			errors
		},
		reset
	} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(Yup.object().shape({
			career: Yup.string().required('Bạn chưa chọn ngành nghề'),
		}))
	});

	useEffect(() => {
		if(item?.id) {
			initialValues.career = item.career;
			initialValues.statusShare = item.statusShare;
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(item, data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Yêu cầu</p>
			<Row className="mb-2" gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="statusShare" render={({field}) => (
						<SelectField label="Trạng thái" options={statusShareOptions} errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="career" render={({field}) => (
						<SelectField label="Ngành nghề" options={careerOptions} errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật website</Button>
			</div>
		</form>
	)
}

export default CreatedWebsiteFormEdit;